import { NavMenuItem, navMenuItemFromResponse } from './NavMenuItem';

export interface Settings {
  settingsV1: Record<string, string>;
  storeSettings: Record<string, string>;
  menu: NavMenuItem[];
  footer1: NavMenuItem[];
  footer2: NavMenuItem[];
}

export const settingsFromResponse = (responseData: any): Settings => ({
  settingsV1: responseData.settings,
  storeSettings: responseData.store_settings,
  menu: (responseData.menu ?? []).map(navMenuItemFromResponse),
  footer1: (responseData.footer1 ?? []).map(navMenuItemFromResponse),
  footer2: (responseData.footer2 ?? []).map(navMenuItemFromResponse),
});
